import { store } from '@utils/configStore'
import marksReducer from './slices'

export const injectMarks = () => store.injectReducer('marks', marksReducer)
